document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    var btn = e.target.closest('button');
    if (btn && (btn.getAttribute('aria-label') === 'add to cart' || (btn.innerText && btn.innerText.toLowerCase().includes('add to cart')))) {
      var form = document.querySelector('.js-product-form');
      if (!form) return;
      var sizeLabel = Array.from(form.querySelectorAll('span, label, div')).find(function(el) {
        return el.textContent && el.textContent.trim() === 'Select Size';
      });
      if (sizeLabel) {
        var selectedButton = form.querySelector('.border-secondary');
        var selectedInput = form.querySelector('input[type="radio"]:checked');
        if (!selectedButton && !selectedInput) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          var top = form.getBoundingClientRect().top + window.scrollY - 150;
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }
      }
    }
  }, true);
});